<template>
  <v-app>
    <v-container>
      <v-row class="justify-center">
        <v-col class="col-12">
          <v-row class="ustify-center align-center flex-column" v-if="isLoading">
            <p>Carregando...</p>
            <v-progress-circular indeterminate color="primary" class="mb-0"></v-progress-circular>
          </v-row>
          <v-snackbar v-model="snackbar" :color="resultSnack" :timeout="3000">
            {{ msg }}
            <v-btn dark text @click="snackbar = false">Close</v-btn>
          </v-snackbar>
          <v-row class="justify-center" v-if="!isLoading">
            <v-col class="col-12 col-md-5 mx-auto">
              <div>
                <v-autocomplete
                  solo
                  flat
                  hide-no-data
                  clearable
                  label="Fuso horário"
                  :items="time_zone"
                  v-model="time_zone_name"
                  @change="timeZone"
                  background-color="#F7F7F7"
                ></v-autocomplete>
              </div>
              <div class="d-inline-flex primary--text">
                <v-icon class="mx-2" color="primary">calendar_today</v-icon>
                <h2>Agendamento</h2>
              </div>
              <!-- <div class="d-flex my-3">
                <v-col class="col-2 col-md-2">
                  <v-avatar size="90">
                    <v-img v-if="user.photo != ''" :src="user.photo">
                      <template v-slot:placeholder>
                        <v-row fill-height align-center justify-center ma-0>
                          <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>

                    <v-img v-if="user.photo == ''" :src="require('../../assets/no-image.png')"></v-img>
                  </v-avatar>
                </v-col>
                <v-col class="col-10 col-md-10 pl-7" style="background: #F7F7F7; padding: 13px 0; border-radius: 12px">
                  <div>
                    <p class="mb-2 font-weight-bold subheading">{{ user.name }}</p>
                    <p class="ma-0">
                      <span class="font-weight-bold">Nacionalidade:</span>
                      {{ user.country }}
                    </p>
                  </div>
                </v-col>
              </div>-->
              <v-col class="col-12 d-flex align-center justify-end my-3">
                <div
                  class="pl-12"
                  style="background: #F7F7F7; padding: 13px 0; border-radius: 12px; width: calc(100% - 46px); position: relative;"
                >
                  <div style="position: absolute; left: -50px; top: 0">
                    <v-avatar size="90">
                      <v-img v-if="user.photo != ''" :src="user.photo">
                        <template v-slot:placeholder>
                          <v-row fill-height align-center justify-center ma-0>
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>

                      <v-img v-if="user.photo == ''" :src="require('../../assets/no-image.png')"></v-img>
                    </v-avatar>
                  </div>
                  <p class="mb-2 font-weight-bold subheading">{{ user.name }}</p>
                  <p class="ma-0">
                    <span class="font-weight-bold">Nacionalidade:</span>
                    {{ user.country }}
                  </p>
                </div>
              </v-col>
              <v-date-picker
                v-model="date"
                :events="arrayEvents"
                full-width
                locale="pt-br"
                event-color="secondary"
                color="primary"
                :min="minDate"
                :picker-date.sync="pickerDate"
              ></v-date-picker>
              <div class="date__slected px-4 py-2">
                <p>
                  Data selecionada:
                  <span>{{date | formatDate}}</span>
                </p>
              </div>
              <div class="my-3">
                <h3 class="primary--text">Horários Disponíveis</h3>
                <v-row class="row wrap px-3">
                  <v-radio-group v-model="selected">
                    <v-radio
                      class="list__hours"
                      v-for="(hour,index) in hoursOpen"
                      :key="index"
                      :label="hour.description"
                      :value="hour.value"
                    ></v-radio>
                  </v-radio-group>
                </v-row>
              </div>

              <div style="display: flex; flex-direction: column;">
                <p class="lightGray pa-4 text-sm-center subheading font-weight-black">
                  Valor da consulta:
                  <span class="secondary--text ml-2">{{value}}</span>
                </p>
                <v-dialog v-model="dialog" persistent max-width="390">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      large
                      color="secondary"
                      style="align-self: center;"
                      :loading="loader"
                      :disabled="isDisabled"
                      v-on="on"
                    >AGENDAR</v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="headline">Confirmar agendamento</v-card-title>
                    <v-card-text>
                      Tem certeza de que deseja realizar o agendamento?
                      <p
                        class="font-weight-bold"
                      >O seu agendamento só será aprovado, caso realize o pagamento pelo link que será enviado ao seu e-mail até 48hrs antes da consulta.</p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray darken-1" text @click="dialog = false">Cancelar</v-btn>
                      <v-btn color="secondary darken-1" text @click="scheduleHours()">OK</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-btn
                  class="mt-6"
                  text
                  style="align-self: center;"
                  @click="$router.go(-1)"
                >Cancelar</v-btn>
              </div>
            </v-col>
            <!-- <v-col class="col-12 col-md-5 mt-5 mx-auto">
              <div class="mb-5">
                <h3 class="primary--text mb-2">Forma de Pagamento</h3>
                <v-row class="py-2 px-4 mb-5 mb-md-12 justify-center lightGray" style="position: relative;">
                  <v-col class="col-12 col-md-5">
                    <p class="subtitle-2 gray--text">Número</p>
                    <div class="align-center d-flex">
                      <v-img :src="require('../../../src/assets/Visa.png')" width="47" height="47"></v-img>
                      <p class="font-weight-black ma-0 primary--text">**** 1122</p>
                    </div>
                  </v-col>
                  <v-col class="col-12 col-md-5">
                    <p class="subtitle-2 gray--text">Validade</p>
                    <p class="font-weight-black ma-0 primary--text text-sm-center">10/23</p>
                  </v-col>
                  <v-btn dark absolute large color="gray" style="bottom: -25%;">ALTERAR CARTÃO</v-btn>
                </v-row>
              </div>
              <div style="display: flex; flex-direction: column;">
                <p class="lightGray pa-4 text-sm-center subheading font-weight-black">
                  Valor da consulta:
                  <span class="secondary--text ml-2">60€</span>
                </p>
                <v-dialog v-model="dialog" persistent max-width="390">
                  <template v-slot:activator="{ on }">
                    <v-btn large color="secondary" style="align-self: center;" :loading="loader" :disabled="isDisabled" v-on="on">AGENDAR</v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="headline">Confirmar agendamento</v-card-title>
                    <v-card-text>
                      Tem certeza de que deseja realizar o agendamento?
                      <p class="font-weight-bold">O seu agendamento só será aprovado, caso realize o pagamento pelo link que será enviado ao seu e-mail até 48hrs antes da consulta.</p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray darken-1" text @click="dialog = false">Cancelar</v-btn>
                      <v-btn color="secondary darken-1" text @click="scheduleHours()">OK</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-btn class="mt-6" text style="align-self: center;" @click="$router.go(-1)">Cancelar</v-btn>
              </div>
            </v-col>-->
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import http from '@/services/httpClient';
import moment from 'moment-timezone';

export default {
  data() {
    return {
      loader: false,
      isDisabled: true,
      isLoading: false,
      dialog: false,
      user: {},
      value: '',
      codPsi: '',
      selected: '',
      date: new Date().toISOString().substr(0, 10),
      arrayEvents: [],
      hoursOpen: [],
      page: 1,
      msg: '',
      snackbar: false,
      resultSnack: '',
      time_zone: moment.tz.names(),
      time_offset: '',
      time_zone_name: '',
      pickerDate: null,
    };
  },
  async created() {
    await this.getCod();
    await this.getUser();
    await this.getTimeZone();
    await this.getHours();
  },
  computed: {
    /**
     * Informa para o datepicker a data minima para ser escolhida.
     */
    minDate() {
      const today = new Date();
      return this.formatDate(today);
    },
  },
  watch: {
    /**
     * Reconhece quando uma a variavel date é modificada e chama a
     * função que pegar as horas livres daquela data.
     */
    async date(val) {
      this.isDisabled = true;
      await this.getHours();
    },
    /**
     * Verifica que ocorreu uma alteração na variavel $selected
     * e desabilita o botão Agendar.
     */
    selected(val) {
      if (val != '') {
        this.isDisabled = false;
      }
    },

    time_zone_name(val) {
      if (val) {
        this.getHours();
      }
    },

    pickerDate(val) {
      this.monthYear(val);
    },
  },
  methods: {
    async monthYear(value) {
      const res = value.split('-');
      const year = res[0];
      const month = res[1];
      if (year != undefined && month != undefined) await this.allScheduleOpneMonth(month, year);
    },
    /**
     * Pega o time zone escolhido pelo paciente
     */
    timeZone(val) {
      const m = moment().tz(val);
      this.time_offset = m.format('Z');
      this.time_zone_name = val;
    },
    /**
     * formata data e retorna para a função que vai informa ao datepicker
     * apartir de que data inicia.
     * params: $date
     */
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join('-');
    },
    /**
     * Pega o id(codigo) do usuario que é passado vai parametro na rota.
     */
    getCod() {
      this.codPsi = this.$route.params.id;
    },
    /**
     * Pega os dados do psicologo
     */
    getUser() {
      this.isLoading = true;
      http
        .get(`/psychologists/${this.codPsi}/`, {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        })
        .then((response) => {
          this.user = response.data;
          this.value = this.user.appointment_br_value == '0.00'
            ? `€ ${this.user.appointment_pt_value}`
            : `R$ ${this.user.appointment_br_value}`;
          console.log(response.data);
        })
        .catch((err) => {
          console.log(err.data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    /**
     * Pega todos os dias e horarios vagos aparti do mês e ano selecionado
     * e coloca em na variavel arrayEvents para ser sinalizado
     * no datapicker os dias que tem horarios vagos.
     */
    async allScheduleOpneMonth(month, year) {
      try {
        const { data, status } = await http.get(
          `/psychologists/${this.codPsi}/time_slots/?year=${year}&month=${month}`,
          {
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        );

        if (status == 200) {
          for (const item of data) {
            this.arrayEvents.push(item.date);
          }
          console.log(data);
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * Pega todos os dias e horarios vagos e coloca em na variavel arrayEvents para poder sinalizar
     * no datapicker os dias que tem horarios vagos.
     */
    // allScheduleOpne: function() {
    //   http.get(
    //     `/psychologists/${this.codPsi}/time_slots/`,
    //     {
    //       params: {
    //         page: this.page
    //       },
    //       headers: {
    //         Authorization: `Token ${localStorage.getItem("user-token")}`
    //       }
    //     }
    //   ).then(response => {
    //     for (const item of response.data.results) {
    //       this.arrayEvents.push(item.date);
    //     }
    //     if(response.data.next != null) {
    //       this.page = this.page + 1;
    //       this.allScheduleOpne();
    //     }
    //   });
    // },
    /**
     * Pega as horas vagas de uma data especifica.
     * Função é chamada quando uma data é escolhida.
     */
    getHours() {
      http
        .get(`/psychologists/${this.codPsi}/time_slots/`, {
          params: {
            date: this.date,
          },
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        })
        .then((response) => {
          this.listHours(response.data);
          this.selected = '';
          // console.log(response.data[0]);
          // console.log(moment.utc(`${response.data[0].date} ${response.data[0].time}`).tz(`${this.time_zone_name}`).format("HH:mm:ss")); // Aqui consigo transforma o data time usando o timezone do usuario.
          // console.log(moment.tz(`2019-11-18 17:53:00`,"America/Bahia").utc().format()); // Aqui pego o UTC - Coordinated Universal Time
          // let utc = moment.tz(`2019-11-18 18:00:00`,`${this.time_zone_name}`).utc().format("HH:mm:ss");
          // console.log(utc, "UTC");
          // console.log(moment.utc(`2019-11-18 ${utc}`).tz(`${this.time_zone_name}`).format("HH:mm:ss"), `formatado para ${this.time_zone_name}`)
          // console.log(moment.utc(`2019-11-18 ${utc}`).local().format("HH:mm:ss"), "Horario local");
          // console.log(moment.utc(`${response.data[0].date} ${response.data[0].time}`).tz(`${this.time_zone_name}`).format("HH:mm:ss"), `formatado para ${this.time_zone_name}`)
          // console.log(moment.utc(`${response.data[0].date} ${response.data[0].time}`).local().format("HH:mm:ss"), "Horario local");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /**
     * Através da array de horarios passado a função gera uma nova array
     * de objeos com value e description
     * { value 15:00, description 15h-16h}.
     */
    async listHours(val) {
      this.hoursOpen = [];

      const listFilter = await val.filter((item) => {
        const utcNow = `${moment.utc().format('YYYY-MM-DD HH:mm:ss')}`;
        const dateTime = `${item.date} ${item.time}`;
        return dateTime > utcNow;
      });

      for (const item of listFilter) {
        item.time = moment
          .utc(`${item.date} ${item.time}`)
          .tz(`${this.time_zone_name}`)
          .format('HH:mm:ss');
        const splitTime = item.time.split(':');
        let axuDesc = parseInt(splitTime[0], 10) + 1;
        axuDesc = `0${axuDesc}`.substr(-2);
        const auxDescription = `${item.time.replace(
          ':00:00',
          'h',
        )}-${axuDesc}h`;
        const auxHours = {
          value: item.id,
          description: auxDescription,
        };
        this.hoursOpen.push(auxHours);
      }
    },
    /**
     * Agenda uma seção com o psicologo, passando o id da data/horario na URL
     * e como parametro o id do paciente.
     */
    scheduleHours() {
      this.dialog = false;
      this.loader = true;
      http
        .post(
          `/psychologists/${this.codPsi}/time_slots/${this.selected}/scheduling/`,
          {
            patient: localStorage.getItem('user-id'),
          },
          {
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        )
        .then((res) => {
          this.isDisabled = true;
          this.msg = 'Agendamento realizado com sucesso!';
          // this.resultSnack = "success";
          this.snackbar = true;
          setTimeout(() => {
            this.$router.replace('/paciente/schedule');
          }, 3000);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loader = false;
        });
    },
    getTimeZone() {
      const data_user = localStorage.getItem('user-data');
      this.time_zone_name = JSON.parse(data_user).time_zone_name;
    },
  },
};
</script>

<style scoped>
* >>> .list__hours {
  margin-top: 0px;
}

* >>> .list__hours .v-input--selection-controls__input {
  display: none;
}

* >>> .v-input--radio-group__input {
  display: flex;
  flex-direction: row !important;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
}

* >>> .list__hours {
  margin-bottom: 0;
  background: #cbcbcb;
  padding: 8px 16px;
  border-radius: 23px;
}

* >>> .list__hours.v-item--active {
  background: #02a554;
}

* >>> .list__hours.v-item--active .v-label {
  color: #fff;
}

* >>> .list__hours .v-label {
  color: #000000;
}

.date__slected {
  background-color: #e3ffe3;
}
.date__slected p {
  color: #6f6f6f;
  margin: 0;
  position: relative;
}
.date__slected p span {
  color: #02a554;
  font-size: 16px;
  font-weight: bold;
  position: absolute;
  right: 5px;
}

/* *>>> .v-date-picker-table .v-btn.v-btn--active,
*>>> .v-date-picker-table .v-btn.v-btn--outlined {
  border-radius: 28px;
} */
</style>
